import { Auth, User as AuthUser } from 'firebase/auth';
import { GetCredentialInteractor } from './get-credential.interactor';
import { getAuthUser } from './get-user.interactor';
import { Subject } from 'rxjs';

export class IsLoggedInteractor {
  constructor(
    private readonly auth: Auth,
    private readonly getCredential: GetCredentialInteractor,
    private readonly userAuthStateChanged$: Subject<AuthUser | undefined>,
  ) {}

  public async execute(): Promise<boolean> {
    try {
      const authUser = await getAuthUser(this.auth, this.userAuthStateChanged$);

      // Check if credential is available
      this.getCredential.execute();

      return authUser !== null;
    } catch {
      return false;
    }
  }
}
